export default (status: string): string => {
  if (status === 'Active') return 'Deactivate';
  if (status === 'Deactivated') return 'Activate';
  if (status === 'Pending') return 'Resend Invitation';
  if (status === 'Locked') return 'Unlock';
  return '';
};
